import React, {
  ReactNode,
} from 'react';
import isNil from 'lodash/isNil';
import Switch, {
  SwitchProps,
  SwitchClasses,
} from '@mui/material/Switch';
import clsx from 'clsx';
import ToolTip from 'core/components/Tooltip';

type Classes = SwitchClasses & {
  rootContainer?: string;
  label?: string;
};

type Props = Omit<SwitchProps, 'classes'> & {
  label?: string;
  activeLabel?: string;
  classes?: Partial<Classes>;
  tooltip?: ReactNode;
};

const activeClasses = 'font-medium text-black';

export default function SwitchButton({
  checked,
  label,
  activeLabel,
  classes,
  tooltip,
  ...props
}: Props) {
  return (
    <div className={clsx('flex items-center gap-2', classes?.rootContainer)}>
      {!isNil(label) && (
        <span className={clsx(
          'font-semibold text-xs !text-gray-500',
          classes?.label,
          { [activeClasses]: !checked },
        )}
        >
          {label}
        </span>
      )}
      <ToolTip title={tooltip} hide={isNil(tooltip)}>
        <div className={clsx({ 'cursor-not-allowed': props.disabled })}>
          <Switch
            focusVisibleClassName=".Mui-focusVisible"
            disableRipple
            classes={classes}
            checked={checked}
            {...props}
          />
        </div>
      </ToolTip>
      {activeLabel && (
        <span className={clsx({ [activeClasses]: checked })}>
          {activeLabel}
        </span>
      )}
    </div>
  );
}
